import { myFetch, HttpMethod } from './baseService';

// Interfaz para la solicitud del dashboard
export interface GetDashboardItemsRequest {
  "tipo usuario codigo": string;
  "permiso para votar": number;
}

// Interfaz para los ítems del dashboard
export interface DashboardItem {
  ipp_codigo: string;
  ipp_nombre: string;
  ipp_ruta_foto: string;
  ipp_prioridad: number;
}

// Interfaz genérica para la respuesta
export interface ApiEnvelope<T> {
  code: string | number;
  message: string;
  object_: T;
}

// Función para obtener los ítems del dashboard
export const getDashboardItems = async (payload: GetDashboardItemsRequest) => {
  const envelope = await myFetch<ApiEnvelope<DashboardItem[]>>(
    'icono_pantalla_principal/ObtenerTodos', // Ajusta la URL según tu API
    HttpMethod.POST,
    payload
  );

  if (!envelope.object_) {
    throw new Error('Respuesta inesperada del servidor');
  }

  return envelope.object_;
};